/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OutputActions_meeting$ref: FragmentReference;
declare export opaque type OutputActions_meeting$fragmentType: OutputActions_meeting$ref;
export type OutputActions_meeting = {|
  +id: string,
  +$refType: OutputActions_meeting$ref,
|};
export type OutputActions_meeting$data = OutputActions_meeting;
export type OutputActions_meeting$key = {
  +$data?: OutputActions_meeting$data,
  +$fragmentRefs: OutputActions_meeting$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OutputActions_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "TacticalMeeting",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'c3f37280266fb8ac368fe9d2bf80b45c';

module.exports = node;
